import "../Styles/Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-col">
          <h4 className="footer-title">Quick Links</h4>
          <ul className="footer-list">
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#research">Research</a></li>
            <li><a href="#experience">Experience</a></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4 className="footer-title">Research Highlights</h4>
          <ul className="footer-list">
            <li><span>Behavioral Economics</span></li>
            <li><span>Consumer Behavior</span></li>
            <li><span>Policy Impact Studies</span></li>
            <li><span>Education & Analytics</span></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4 className="footer-title">Connect</h4>
          <address className="contact-block">
            <div>Sonipat, India</div>
            <div>+91-7419614691</div>
            <a href="mailto:tankp.neupane@jgu.edu.in">tankp.neupane@jgu.edu.in</a>
          </address>

          <div className="footer-social">
            <a className="social-button" href="https://www.linkedin.com/in/tank-prasad-neupane-27185198/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden>
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a className="social-button" href="mailto:tankp.neupane@jgu.edu.in" aria-label="Email">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                <rect x="3" y="5" width="18" height="14" rx="2"/>
                <path d="M3 7l9 6 9-6"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bar">
        <div className="copyright">
          © {year} Tank Prasad Neupane. All rights reserved
          <span className="sep">|</span>
         Privacy Policy
        </div>
        <div className="bar-icons">
          <span className="dot" />
          <span className="dot" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;


